import React from 'react';
import FormDialog from '../../../library/form/components/FormDialog';
import withView from '../../cmn/docAutomation/withView';
import FormInput from '../../../library/form/components/FormInput';
import FormCheckbox from '../../../library/form/components/FormCheckbox';
import FormLabel from '../../../library/form/components/FormLabel';
import FormRichText from '../../../library/form/components/FormRichText';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormTitle from '../../../library/form/components/FormTitle';
import FormSH from '../../../library/form/components/FormSH';
import { UiGridColTwo, UiCol } from "../../../library/layout/Index";

const ProAddressEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{height: '370px'}}
            formStyle={{ width: '743px' }} formTitle={<FormTitle formObject={formObject} value="Profile Address" />} 
        >
            <UiGridColTwo>
                <UiCol>
                    <ul >
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "addType" }} value="Address Type" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" autofocus className=""
                                    action={{ InputType: "ac", paramName: "addType", acMethod:"CategoryDetail", acDepCtrl:{ 'dparam': "%dataList.valLCat" } }}
                                />
                                <FormSH formObject={formObject} rowKey=""
                                    action={{ actionId: "new", paramName: "addType",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                                     >
                                </FormSH>
                            </div>
                        </li>
                        <li style={{height:"120px"}}>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "streeAdd1" }} value="Street Address" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="streeAdd1Txt" className=""
                                    action={{ InputType: "input", paramName: "streeAdd1" }}
                                />
                                <span className="uiLbl"></span>
                                <FormInput formObject={formObject} rowKey="" id="streeAdd2Txt" className="uiSpacer10 uiInput"
                                    action={{ InputType: "input", paramName: "streeAdd2" }}
                                />
                                <span className="uiLbl"></span>
                                <FormInput formObject={formObject} rowKey="" id="streeAdd3Txt" className="uiSpacer10 uiInput"
                                    action={{ InputType: "input", paramName: "streeAdd3" }}
                                />
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "town" }} value="City / Town" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="townTxt" className=""
                                    action={{ InputType: "input", paramName: "town" }}
                                />
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "state" }} value="State" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="stateTxt" className=""
                                    action={{ InputType: "input", paramName: "state" }}
                                />
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "country" }} value="Country" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="countryTxt" className=""
                                    action={{ InputType: "ac", paramName: "country", acMethod:"Country" }}
                                />
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "pincode" }} value="Postal Code" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="pincodeTxt" className=""
                                    action={{ InputType: "input", paramName: "pincode" }}
                                />
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "landmark" }} value="Landmark" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" id="landmarkTxt"
                                    action={{ InputType: "input", paramName: "landmark" }}
                                />
                            </div>
                        </li>
                    </ul>
                </UiCol>
                <UiCol>
                    <ul>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "delHours" }} value="Delivery Hrs" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="delHrsTxt" className=""
                                    action={{ InputType: "input", paramName: "delHours" }}
                                />
                            </div>
                        </li>
                        <li style={{height:"120px"}}>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "delInst" }} value="Delivery Instructions" />
                                </span>
                                <FormRichText formObject={formObject} rowKey="" id="delInstTxt" className="" rows="3" cols="30"
                                    action={{ paramName: "delInst" }}
                                />
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "delMode" }} value="Delivery Mode" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" id="deliveryModeTxt"
                                    action={{ InputType: "ac", paramName: "delMode", acMethod:"CategoryDetail", acDepCtrl:{ 'dparam': '%dataList.valLCat' } }}
                                />
                                <FormSH formObject={formObject} rowKey=""
                                    action={{ actionId: "new", paramName: "delMode",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                                    >
                                </FormSH>
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "delTrans" }} value="Transporter Name" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" id="transporterTxt"
                                    action={{ InputType: "input", paramName: "delTrans" }}
                                />
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "mySampleInput1" }} value="Working Days" />
                                </span>
                                <fieldset style={{display:"inline-block"}}>

                                    <FormCheckbox formObject={formObject} rowKey='' name="cbcostextravalue" id="proWorkdMon"
                                        action={{ InputType: "switch", paramName: "wsMon" }} text={<SarasTrans trKey="MondayAbbrIn" value="M" />}
                                    />

                                    <FormCheckbox formObject={formObject} rowKey='' name="cbcostextravalue" id="proWorkdTue"
                                        action={{ InputType: "switch", paramName: "wsTue" }} text={<SarasTrans trKey="TuesdayAbbrIn" value="T" />}
                                    />

                                    <FormCheckbox formObject={formObject} rowKey='' name="cbcostextravalue" id="proWorkdWed"
                                        action={{ InputType: "switch", paramName: "wsWed" }} text={<SarasTrans trKey="WednesdayAbbrIn" value="W" />}
                                    />

                                    <FormCheckbox formObject={formObject} rowKey='' name="cbcostextravalue" id="proWorkdThu"
                                        action={{ InputType: "switch", paramName: "wsThu" }} text={<SarasTrans trKey="ThursdayAbbrIn" value="T" />}
                                    />

                                    <FormCheckbox formObject={formObject} rowKey='' name="cbcostextravalue" id="proWorkdFri"
                                        action={{ InputType: "switch", paramName: "wsFri" }} text={<SarasTrans trKey="FridayAbbrIn" value="F" />}
                                    />

                                    <FormCheckbox formObject={formObject} rowKey='' name="cbcostextravalue" id="proWorkdSat"
                                        action={{ InputType: "switch", paramName: "wsSat" }} text={<SarasTrans trKey="SaturdayAbbrIn" value="S" />}
                                    />

                                    <FormCheckbox formObject={formObject} rowKey='' name="cbcostextravalue" id="proWorkdSun"
                                        action={{ InputType: "switch", paramName: "wsSun" }} text={<SarasTrans trKey="SundayAbbrIn" value="S" />}
                                    />

                                </fieldset>
                            </div>
                        </li>
                        <li>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "contact" }} value="Contact Person" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" id="contactTxt"
                                    action={{ InputType: "input", paramName: "contact" }}
                                />
                            </div>
                        </li>
                        <li>
                            
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isDefault" }} value="Set Default" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey='' name="cbcostextravalue" id="proAddMakeDefault"
                                    action={{ InputType: "onOff", paramName: "isDefault" }}
                                />
                            
                        </li>
                    </ul>
                </UiCol>
            </UiGridColTwo>
        </FormDialog>
    )
}

export default  withView(ProAddressEditor, "proAddress", "proAddress")